module.exports = __webpack_public_path__ + "img/icon-15.b1f305d4.svg";